import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, getCurrentInstance, watch } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
import { PurchaseDetails } from '@/components/Billing/billing-types';
// @ts-ignore
import PaymentInfoInput from '@/components/Payment/Stripe/PaymentInfoInput.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { PlanPurchaseError } from '@/utils/error-handling-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeMultiplePlansPayment',
  props: {
    buttonText: { default: 'Confirm purchase' },
    totalDueToday: null,
    purchaseProduct: { type: Boolean, default: true },
    newPurchaseDetails: null,
    prefillDefaultPaymentMethod: { type: Boolean, default: true },
    currentPurchaseDetails: null
  },
  emits: ["close", "loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void;
	(e: 'loading', isLoading: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { buttonText: string, totalDueToday?: string, purchaseProduct: boolean, newPurchaseDetails?: PurchaseDetails, prefillDefaultPaymentMethod: boolean, currentPurchaseDetails?: PurchaseDetails }



const customerInvoiceName = ref('');

const { upgradeBillingPlans, useDefaultPaymentMethod } = useBilling();
const defaultPaymentMethod = useDefaultPaymentMethod();

const toast = getCurrentInstance()?.proxy.$toast;
const isFreeUpdate = computed(() => props.totalDueToday === '$0');

const purchaseButtonText = computed(() => {
	if (isFreeUpdate.value) {
		return 'Update';
	} else {
		return props.buttonText || 'Confirm purchase';
	}
});

const paymentInfoInputRef = ref();
const isCardFormValid = ref(false);
const isLoadingPurchase = ref(false);
const isLoadingSetPayment = ref(false);
const hasValidPaymentMethod = computed(() => defaultPaymentMethod.value?.type === 'card');
const isPurchaseButtonLoading = computed(() => isLoadingPurchase.value || isLoadingSetPayment.value);
watch(isPurchaseButtonLoading, (newV) => {
	emit('loading', newV);
});
const isPurchaseButtonDisabled = computed(() => {
	if (hasValidPaymentMethod.value) {
		return isPurchaseButtonLoading.value;
	} else {
		return (!isCardFormValid.value && !isFreeUpdate.value) || isPurchaseButtonLoading.value;
	}
});
const confirmPurchase = () => {
	if ((hasValidPaymentMethod.value && props.purchaseProduct) || isFreeUpdate.value) {
		completePurchase();
	} else {
		paymentInfoInputRef.value?._setupState?.generateCardToken();
	}
};
watch(isLoadingSetPayment, (newV, oldV) => {
	if (oldV && !newV) {
		completePurchase();
	}
});
const completePurchase = async () => {
	if (props.newPurchaseDetails) {
		try {
			isLoadingPurchase.value = true;
			await upgradeBillingPlans({ purchaseDetails: props.newPurchaseDetails, customerInvoiceName: customerInvoiceName.value });
			toast?.success('Purchase completed successfully');
			emit('close');
		} catch (e) {
			onError(e);
		} finally {
			isLoadingPurchase.value = false;
		}
	}
};
const onError = (e: unknown) => {
	console.error('error occurred while completing purchase', e);
	isLoadingSetPayment.value = false;
	if (e instanceof PlanPurchaseError) {
		const message = JSON.parse(e.message);
		AppDialogManagerService.openCouldntDowngradeBillingPlanDialog({ message });
	}
	toast?.error('Error occurred while processing payment, please contact support');
};

return { __sfc: true,emit, props, customerInvoiceName, upgradeBillingPlans, useDefaultPaymentMethod, defaultPaymentMethod, toast, isFreeUpdate, purchaseButtonText, paymentInfoInputRef, isCardFormValid, isLoadingPurchase, isLoadingSetPayment, hasValidPaymentMethod, isPurchaseButtonLoading, isPurchaseButtonDisabled, confirmPurchase, completePurchase, onError, PaymentInfoInput }
}

})